import React, { useRef, useState } from "react";
import { Modal, Row, Form, Button, Col } from "react-bootstrap";
import PhoneInputComponent from "./PhoneInputComponent"; // adjust the path as needed
import { useTranslation } from "react-i18next";
import axios from "../../src/axios";
import { Toast } from "primereact/toast";
import { useNavigate } from "react-router-dom";

const ShuttleModal = ({ show, setShow, destination_id, room_uuid }) => {
  const { t } = useTranslation();
  const [activityData, setActivityData] = useState({
    number_of_people: "",
    phone: "",
    email: "",
  });

  const [errnumberAdults, setErrNumberAdults] = useState("");
  const [errPhone, setErrPhone] = useState("");
  const [errEmail, setErrEmail] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);
  const newDesign = localStorage.getItem("new_design");
  const theme = newDesign === "true";
  const toast = useRef(null);
  const navigate = useNavigate();

  const handleClose = () => {
    setShow(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setActivityData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateInputs = () => {
    let valid = true;
    setErrNumberAdults("");
    setErrPhone("");
    setErrEmail("");

    if (!activityData.number_of_people || activityData.number_of_people < 1) {
      setErrNumberAdults("Please enter a valid number of people.");
      valid = false;
    }

    if (!activityData.phone) {
      setErrPhone("The phone field is required.");
      valid = false;
    }

    if (!activityData.email || !/\S+@\S+\.\S+/.test(activityData.email)) {
      setErrEmail("Please enter a valid email address.");
      valid = false;
    }

    return valid;
  };

  const handleBook = async () => {
    if (!validateInputs()) return;

    setIsDisabled(true);

    try {
      const formData = new FormData();
      formData.append("phone", activityData.phone);
      formData.append("email", activityData.email);
      formData.append("type_id", "shuttle");
      formData.append("destination_id", destination_id);
      formData.append("people_no", activityData.number_of_people);

      const response = await axios.post(
        `${room_uuid}/concierge/book-service`,
        formData,
        {
          headers: {
            Accept: "application/json",
          },
        },
      );

      if (response.data.status == false) {
        toast.current.show({
          severity: "error",
          summary: t("Error"),
          detail: t(`${response.data.message}`),
          life: 4000,
        });
      }
      // console.log("res", res);
      if (response.data.status) {
        navigate(`/${room_uuid}/HKOrderPlaced`, {
          state: {
            metadata: {
              res: response.data.data,
            },
          },
        });
      }
      handleClose();
    } catch (error) {
      console.error("Booking failed:", error);
      alert(t("Booking failed. Please try again."));
    } finally {
      setIsDisabled(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      className={`custom-width pt-4 ${theme ? "food-modal" : ""}`}
      centered
    >
      <Toast ref={toast} position="bottom-center" />
      <Modal.Body style={{ paddingTop: "3rem" }}>
        <button
          type="button"
          className="button close-pop"
          onClick={handleClose}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24.054"
            height="24.625"
            viewBox="0 0 24.054 24.625"
          >
            <defs></defs>
            <path
              id="Icon_ionic-ios-close-circle"
              data-name="Icon ionic-ios-close-circle"
              className="cls-50"
              d="M15.4,3.375A12.17,12.17,0,0,0,3.375,15.687,12.17,12.17,0,0,0,15.4,28,12.17,12.17,0,0,0,27.429,15.687,12.17,12.17,0,0,0,15.4,3.375Zm3.047,16.77L15.4,17.025l-3.047,3.12a.913.913,0,0,1-1.307,0,.959.959,0,0,1,0-1.338l3.047-3.12-3.047-3.12a.959.959,0,0,1,0-1.338.913.913,0,0,1,1.307,0L15.4,14.35l3.047-3.12a.913.913,0,0,1,1.307,0,.966.966,0,0,1,0,1.338l-3.047,3.12,3.047,3.12a.966.966,0,0,1,0,1.338A.9.9,0,0,1,18.449,20.145Z"
              transform="translate(-3.375 -3.375)"
            ></path>
          </svg>
        </button>
        <div className="body-container maintenance ">
          <div className="content-pnl">
            <div className="input-pnl">
              <Row style={{ width: "100%" }}>
                <Form.Group
                  className="mb-3 dark-placeholder i-f-small"
                  controlId="formBasicname"
                  style={{ width: "100%" }}
                >
                  <Form.Control
                    type="number"
                    placeholder={t("Number of People")}
                    name="number_of_people"
                    value={activityData.number_of_people}
                    onChange={handleInputChange}
                  />
                </Form.Group>

                {errnumberAdults && (
                  <span className="err_msg">{t(errnumberAdults)}</span>
                )}
              </Row>
              <Row style={{ width: "100%" }}>
                <Form.Group className="mb-3 dark-placeholder i-f-small w-100">
                  <PhoneInputComponent
                    value={activityData.phone}
                    onChange={(phone) =>
                      setActivityData((prev) => ({
                        ...prev,
                        phone,
                      }))
                    }
                  />
                </Form.Group>
                {errPhone && <span className="err_msg">{t(errPhone)}</span>}
              </Row>

              <Row style={{ width: "100%" }}>
                <Form.Group
                  className="mb-3 dark-placeholder i-f-small"
                  controlId="formBasicEmail"
                  style={{ width: "100%" }}
                >
                  <Form.Control
                    type="email"
                    placeholder={t("Your Email")}
                    name="email"
                    value={activityData.email}
                    onChange={handleInputChange}
                  />
                </Form.Group>
                {errEmail && <span className="err_msg">{t(errEmail)}</span>}
              </Row>
            </div>
            <div className="padd-div text-center mb-2 ">
              <Button
                className="reg-btn book fw-normal"
                onClick={handleBook}
                disabled={isDisabled}
              >
                {t("request")}
              </Button>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ShuttleModal;
